import { EmployeeModelType } from '@teinor/erp/types/company/userInner/employee'
import { EmployeeTimetableModelType } from '@teinor/erp/types/company/userInner/employee/employeeTimetable'
import { useState, useCallback, useEffect } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { DisplayStatusWithoutIcon } from '../../../Displays/DisplayStatus'
import { VirtualTableListingStateLess } from '../../../TwinTable/VirtualTableListing'
import { CustomRenderDateHours, CustomRenderString } from '../../../TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../TwinTable/VirtualTableListing/Subcomponents/types'
import { TwinDictionary } from '../../../../utils/globals/dictionary'

interface LastEmployeeTimetableProps { }

const LastEmployeeTimetable: React.FC<LastEmployeeTimetableProps> = () => {
    const { t } = useTwinTranslation()
    const title = t('latestEmployeeEntries', 'Últimas entradas de empleados')

    return (
        <div className='flex flex-auto flex-col'>
            <h3 className='pb-15'>{title}</h3>
            <TableLastEmployeeTimetable/>
        </div>
    )
}

const TableLastEmployeeTimetable= () => {
    const { t } = useTwinTranslation()
    const { data } = useTableLastEmployeeTimetableLogic()
   
    const dict = {
        active: {
            color: 'text-green-21',
            text: t('working', 'Trabajando'),
        },
        inactive: {
            color: 'text-gray-9D',
            text: t('inactive', 'Inactivo')
        }
    }
    
    const columns: ColumnTableSchema<EmployeeModelType & EmployeeTimetableModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('employee', 'Empleado'),
            customRender: (parameterValue, allRowData) => <CustomRenderString value={allRowData?.fullname_short} />
        },
        {
            id: 'og_start_time',
            dataKey: 'og_start_time',
            label: t('from', 'Desde'),
            customRender: (parameterValue, allRowData) => <CustomRenderDateHours value={allRowData?.EmployeeTimetables?.[0]?.edited_start_time || allRowData?.EmployeeTimetables?.[0]?.og_start_time} />
        },
        {
            id: 'og_end_time',
            dataKey: 'og_end_time',
            label: t('to', 'Hasta'),
            customRender: (parameterValue, allRowData) => <CustomRenderDateHours value={allRowData?.EmployeeTimetables?.[0]?.edited_end_time || allRowData?.EmployeeTimetables?.[0]?.og_end_time} />
        },
        {
            id: 'approved',
            dataKey: 'og_end_time',
            label: t('status', 'Estado'),
            customRender: (parameterValue, allRowData) => {
                const isWorking = allRowData.isWorking
                return <DisplayStatusWithoutIcon colorText={isWorking ? dict.active.color : dict.inactive.color} text={isWorking ? dict.active.text : dict.inactive.text} />
            }
        },
    ]

    return (
        <div className='flex-auto'>
            <VirtualTableListingStateLess tableData={data} rowHeight={48} headerHeight={48} name='LastEmployeeTimetableDashboard' columns={columns} setSelectedColumnsAndFilters={() => { }} updateEmployeeParameter={false} />
        </div>
    )
}

const useTableLastEmployeeTimetableLogic = () => {
    const [data, setData] = useState<any | null>(null)

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/workingCalendar/getAllEmployeesWithLastTimetable', {})
        if (result) {
            const myData: {
                active: TwinDictionary[];
                unactive: TwinDictionary[];
            } = {active: [], unactive: []}
            for (const element of result) {
                const isWorking = element?.EmployeeTimetables?.length && (!element?.EmployeeTimetables?.[0]?.og_end_time && !element?.EmployeeTimetables?.[0]?.edited_end_time)
                element.isWorking = isWorking
                if (isWorking) {
                    myData.active.push(element)
                } else {
                    myData.unactive.push(element)
                }
            }
            setData([...myData.unactive, ...myData.active])
        }
    }, [setData])

    useEffect(() => {
        getData()
    }, [getData])

    return {data}
}

export default LastEmployeeTimetable
